import type { Period } from "../../hooks/reactQueryHooks/useAnalytic";

export class ChartUtils {
  static getTypePeriod(dateFilter: { fromDate: Date; toDate: Date }): Period {
    const { fromDate, toDate } = dateFilter;
    const differenceInMs = toDate.getTime() - fromDate.getTime();
    const differenceInMinutes = Math.round(differenceInMs / (1000 * 60));
    const differenceInHours = Math.round(differenceInMs / (1000 * 60 * 60));
    const differenceInDays = Math.round(differenceInMs / (1000 * 60 * 60 * 24));
    const differenceInMonths = Math.round(
      differenceInMs / (1000 * 60 * 60 * 24 * 30),
    );

    if (differenceInMinutes <= 15) {
      return "minute";
    }
    if (differenceInHours <= 1) {
      return "minute";
    }
    if (differenceInHours <= 24) {
      return "hour";
    }
    if (differenceInDays <= 7) {
      return "day";
    }
    if (differenceInMonths <= 1) {
      return "day";
    }
    if (differenceInMonths <= 3) {
      return "week";
    }
    if (differenceInMonths <= 6) {
      return "week";
    }
    return "month";
  }
  static getXAxisLabel(period: Period, date: string): string {
    switch (period) {
      case "minute": {
        const formatter = new Intl.DateTimeFormat("en-US", {
          hour: "numeric",
          minute: "numeric",
        });
        return formatter.format(new Date(date));
      }
      case "hour": {
        const formatter = new Intl.DateTimeFormat("en-US", {
          hour: "numeric",
          minute: "numeric",
        });
        return formatter.format(new Date(date));
      }

      case "day": {
        const formatter = new Intl.DateTimeFormat("en-US", {
          day: "numeric",
          month: "short",
        });
        return formatter.format(new Date(date));
      }
      case "week": {
        const sixDays = 1000 * 60 * 60 * 24 * 6;
        const formatter = new Intl.DateTimeFormat("en-US", {
          day: "numeric",
          month: "short",
        });
        const dateObj = new Date(date);
        const weekStartDate = formatter.format(dateObj);
        const weekEndDate = new Date(dateObj.getTime() + sixDays);
        return weekStartDate + " - " + formatter.format(weekEndDate);
      }
      default:
        return new Intl.DateTimeFormat("en-US", {
          month: "short",
          year: "numeric",
        }).format(new Date(date));
    }
  }
}
